import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import formMiddleware from './middlewares/form';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';

const middleware = [thunk, formMiddleware];

const store = createStore(rootReducer, undefined, composeWithDevTools(applyMiddleware(...middleware)));
export const persistor = persistStore(store);

export default store;
